import { CYOA_NETWORK_IDS } from '../config';

//Get the network id for CYOA
export const getCyoaID = (parsed) =>{
    return (parsed.destination === CYOA_NETWORK_IDS["usa"].name ) ? CYOA_NETWORK_IDS["usa"].id : CYOA_NETWORK_IDS["europe"].id ;
}
  
//Get the network name for CYOA (Europe / Usa)
export const getCyoaName = (parsed) =>{
    return (parsed.destination === CYOA_NETWORK_IDS["usa"].name ) ? CYOA_NETWORK_IDS["usa"].name : CYOA_NETWORK_IDS["europe"].name ;
}